"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M19.788 5.71C18.385 3.948 16.178 2.532 14 2v2.681a7.736 7.736 0 013.828 2.587 7.594 7.594 0 011.668 4.776 7.591 7.591 0 01-1.668 4.775A7.736 7.736 0 0114 19.406V22c2.178-.532 4.386-1.861 5.789-3.623A10.205 10.205 0 0022 12.044a10.21 10.21 0 00-2.212-6.334zM11.694 3L6.178 8.547H3.793c-.99 0-1.793.81-1.793 1.81v3.285c0 1 .802 1.81 1.793 1.81h2.385L11.694 21V3z" }),
    React.createElement("path", { d: "M14 7v10c2.076-.925 3.5-2.815 3.5-5S16.075 7.925 14 7z" })), "Loud");
//# sourceMappingURL=VolumeLoud.js.map